import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default async function checkAuthenticator ({ to, store }) {
  const school = store.getters['users/me']?.school || store.state.school

  const bas2FA = store.getters['schoolBranding/getBrandingConfig'].start.sdui_authenticator ||
    GlobalPrototypes.can('totp-2fa', school)

  if (bas2FA) return
  if (store.state.authToken) return { ...GlobalPrototypes.defaultRoute(), replace: true }
  if (to.name === 'login-start') return
  return { name: 'login-start', params: to.params }
}
